import styled from 'styled-components';
import { colors, typography, dimensions } from 'modules/common/styles';

const AuthTextBox = styled.div`
  margin: auto;
  background: #fff;
  width: 214px;
  height: 72px;
  /* position: absolute; */
  border-radius: 50px;
  padding-top: 14px;
  // box-shadow: 0px 12px 25px rgba(0, 0, 0, 0.1);
  h2 {
    color: #023372;
    font-size: 22px;
    font-weight: 500;
    margin: 0px;
    text-align: center;
  }
`;

const AuthBox = styled.div`
  /* background-color: ${colors.colorWhite}; */
  padding: 40px 50px;
  // box-shadow: 0px 12px 25px rgba(0, 0, 0, 0.1);
  border-radius: 35px;
  /* text-align: center; */
  // margin: 50px;
  // margin-top: -40px;
  margin: auto;
  max-width: 500px;
  width: 100%;

  @media (max-width: 768px) {
    margin: 0px;
    /* padding: 25px; */
    margin-top: -50px;
    padding-left: 15%;
    text-align: center;
    
  }


  @media (max-width: 768px) {
  .icon {
    transform: translateX(-100px);
  }
}






  

  .otp {
    // width: 46%;
    // margin: auto;
    input {
      height: auto;
      padding: 8px;
      font-size: 15px;
      font-weight: 700;
      /* text-align: center; */
    }
  }

  // .otp .sc-gipzik.fNpEJH {
  //   padding-right: 9px;
  //   margin-top: 15px;
  //   padding-left: 9px;
  // }

  h2 {
    color: #023372;
    font-size: 18px;
    font-weight: 500;
    margin: 0 0 45px;
  }

  p {
    letter-spacing: 0.48px;
    color: #626262;
    font-weight: 600;
    font-size: 16px;
    margin-bottom: 30px;
  }

  label {
    font-size: 13px;
    font-weight: 500;
    letter-spacing: 0.26px;
    // color: #242424;
  }

  input {
    padding: 20px 60px 20px 60px;
    color: ${colors.colorCoreBlack};
    font-size: 15px;
    outline: 0;
    // background: #FAF8FF;
    border: 0.800000011920929px solid blue;
    border-radius: 35px;
    @media (max-width: 768px) {

    }

    &:focus {
      outline: 0;
      box-shadow: none;
      border-color: ${colors.colorPrimary};
      background: #faf8ff;
    }

    input:-internal-autofill-selected {
      background: none;
    }
  }

  button {
    // text-transform: uppercase;
    // // font-weight: 600;
    // margin-top: 50px;
    border: 0;
    // box-shadow: 0px 10px 20px rgba(2, 51, 114, 0.2);
    border-radius: 9px;
    padding: 8px 22px;
  }

  .line {
    width: 100%;
    text-align: center;
    border-bottom: 1px solid #f0f1ff;
    /* line-height: 0.1em; */
    margin: 35px;
    margin-bottom: 40px;
    margin-left: 0%;
  }

  .line span {
    background: #fff;
    padding: 0 10px;
    color: #afafb5;
    font-size: 14px;
  }
`;


const Links = styled.div`
  /* margin-top: -5px; */
  text-align: center;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  @media (max-width: 768px) {
    align-items: center;
    flex-direction:column;
    margin-top:20px;
    transform: translateX(-30px);

}

  a {
    color: ${colors.colorPrimary};
    font-weight: 500;
  }
`;

const Avatar = styled.div`
  img {
    display: block;
    width: 100px;
    height: 100px;
    border-radius: 50px;
  }
`;

const ProfileWrapper = styled.div`
  display: flex;
`;

const ProfileColumn = styled.div`
  flex: 1;
  padding-right: 40px;

  &:last-of-type {
    padding: 0;
  }
`;

const ColumnTitle = styled.h4`
  text-transform: uppercase;
  font-weight: ${typography.fontWeightMedium};
  border-bottom: 1px dotted ${colors.colorShadowGray};
  padding-bottom: ${dimensions.unitSpacing}px;
  font-size: 14px;
  margin: ${dimensions.coreSpacing}px 0;
`;

export {
  AuthBox,
  Links,
  ProfileWrapper,
  ProfileColumn,
  ColumnTitle,
  Avatar,
  AuthTextBox
};



// WEBPACK FOOTER //
// ./src/modules/auth/styles.js